// extracted by mini-css-extract-plugin
export default {"link":"style_link__u1jQf","centerGrid":"style_centerGrid__o8QE0","img":"style_img__Nzqj3","namegame":"style_namegame__dHdry"};